import React from "react";
import { BackButton } from "./BackButton";
import { NextButton } from "./NextButton";
import { ModalDialog } from "./ModalDialog";

export const GenericModal = ({
	show,
	onClose,
	onNext,
	title,
	text,
	bgClass,
	backText,
	nextText,
	nextButton
}) => {
	return (
		<ModalDialog show={show} onClose={onClose}>
			<div
				className={`relative bg-white text-black flex flex-col transition-all transform max-w-sm shadow-lg p-3 sm:p-4 rounded-lg`}
			>
				<h5 className={"text-lg font-bold block text-center"}>{title}</h5>
				<p className={"my-6 xs:my-10 text-center"}>{text}</p>
				<div className="flex justify-around gap-2">
					<div className="w-1/2">
						<BackButton
							onClick={onClose}
							variant={(nextButton || onNext) ? "inactive" : "active"}
							textOverride={backText}
							showIcon={false}
						/>
					</div>

					{nextButton 
					? (
						<div className="w-1/2">
							<div className="w-full noOutlineOnFocus">
								{nextButton}
							</div>
						</div>
					) : (onNext ? (
						<div className="w-1/2">
							<NextButton
								onClick={onNext}
								textOverride={nextText}
								variant={"active"}
							/>
						</div>
					) : null)}
				</div>
			</div>
		</ModalDialog>
	);
};
